import React from 'react';
import BaseModal from '@src/components/modal';
import InviteCodeListComp from './code-list';
import store from './store';

const InviteFormModal = {
  self: null,
  show(data = {}) {
    this.self = BaseModal.show({
      wrapClassName: 'nw-base-modal nw-base-modal-p-0 invite-code-list-modal',
      borderRadius: 24,
      // getContainer: document.getElementById('nworld-app-container'),
      // closable: false,
      content: (
        <InviteCodeListComp
          {...data}
          onClose={() => {
            this.close();
          }}
        ></InviteCodeListComp>
      ),
      afterClose: () => {
        this.close();
      },
    });
  },
  close() {
    if (this.self) {
      this.self.destroy();
      this.self = null;
      store.reset();
    }
  },
};

export default InviteFormModal;
